import { NgModule, Pipe, PipeTransform } from '@angular/core';
import { DataAccessPolicy, instanceofRoleAccessPolicy, RoleAccessPolicy } from '@mtna/pojo-consumer-ts';

@Pipe({ name: 'rdsIsRoleAccessPolicy' })
export class RdsIsRoleAccessPolicyPipe implements PipeTransform {
  transform(dataAccessPolicy: DataAccessPolicy | undefined): RoleAccessPolicy | undefined {
    if (instanceofRoleAccessPolicy(dataAccessPolicy)) {
      return dataAccessPolicy;
    } else {
      return undefined;
    }
  }
}

@NgModule({
  exports: [RdsIsRoleAccessPolicyPipe],
  declarations: [RdsIsRoleAccessPolicyPipe],
})
export class RdsIsRoleAccessPolicyPipeModule {}
